import React from 'react';
import Modal from '@/components/ui/Modal/Modal.tsx';
import styles from './AskASpecialistModal.module.scss';
import { trackPostHogEvent } from '@/utils/productAnalyticsUtil.ts';

const AskASpecialistModal: React.FC = () => {
	return (
		<Modal name="askASpecialist" className={styles.askASpecialistModal}>
			<h3>Would you like to email our support team?</h3>
			<a
				href="mailto:service@goodwings.com"
				onClick={() => trackPostHogEvent('ask_specialist_send_email', { category: 'help' })}
			>
				Send email
			</a>
		</Modal>
	);
};

export default AskASpecialistModal;
